class HolloraRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rail-track]');
    this.nav = this.querySelector('[data-rail-nav]');
    if (!this.track) return;
    this.prev = this.querySelector('[data-rail-prev]');
    this.next = this.querySelector('[data-rail-next]');

    if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
    if (this.next) this.next.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', () => this.sync(), { passive: true });
    window.addEventListener('resize', () => this.sync(), { passive: true });
    this.sync();
  }

  step(dir) {
    const card = this.track.firstElementChild;
    const amount = card ? card.getBoundingClientRect().width + 24 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: amount * dir, behavior: 'smooth' });
  }

  sync() {
    const overflowing = this.track.scrollWidth - this.track.clientWidth > 8;
    if (this.nav) this.nav.classList.toggle('is-active', overflowing);
    if (!overflowing) return;
    const max = this.track.scrollWidth - this.track.clientWidth - 4;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}

if (!customElements.get('hollora-rail')) {
  customElements.define('hollora-rail', HolloraRail);
}
